module.exports = __webpack_public_path__ + "static/media/RO.fecca398.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/RO.svg
// module id = 347
// module chunks = 0